import React from "react";
import propTypes from "prop-types";
import { connect } from "react-redux";
import ProgressRing from "../ProgressRing/ProgressRing";
import loaderBackground from "../../assets/images/loaderBackground.png";
import "./Loader.css";
import * as actions from "../../actions/index";

class Loader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      progress: 0,
      finished: false
    };
  }
  componentDidMount() {
    // emulating progress
    const interval = setInterval(() => {
      this.setState({ progress: this.state.progress + 5 });
      if (this.state.progress === 100) {
        this.setState({ finished: true });
        clearInterval(interval);
      }
    }, 200);
  }
  render() {
    const { allImagesLoaded, progress } = this.props;
    return (
      <React.Fragment>
        {!allImagesLoaded && (
          <section
            // className={`loader ${allImagesLoaded === true ? "hide" : "show"}`}
            className={`loader show`}
            style={{backgroundImage: `url(${loaderBackground})`}}
          >
            <h1 className="loader__title">ABB Data Centers Portal</h1>
            <ProgressRing radius={80} stroke={5} progress={progress} />
            <p className="loader__text">Loading Content</p>
            <p className="loader__percentage">{`${progress}%`}</p>
          </section>
        )}
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    loader: state.navigation.loader,
    loaderProgress: state.navigation.loaderProgress
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setLoader: bool => {
      dispatch(actions.setLoader(bool));
    },
    setLoaderProgress: percentage => {
      dispatch(actions.setLoaderProgress(percentage));
    }
  };
}

Loader.propTypes = {
  loader: propTypes.bool.isRequired
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Loader);
